<template>
  <div>

    <div @click="back()" style="height: 30px;width: 60px;display: flex;align-items: center;cursor: pointer;">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path
          d="M10.9825 3.58692L10.2867 2.89111L3.85938 9.3198L10.2867 15.7478L10.9825 15.052L5.24986 9.31938L10.9825 3.58692Z"
          fill="#595959" />
      </svg>
      <span style="margin-left: 1px;margin-top: -2px;color: #595959;">返回</span>
    </div>

    <div style="height: 100%;width: 100%;">

      <div class="content-head">
        <div class="head-title">收入/利润均衡</div>
        <div class="head-search">
          <!-- <el-input v-model="searchText" placeholder="证券简称或代码"></el-input> -->
          <!--                <el-date-picker v-model="queryParam.year" format="yyyy" value-format="yyyy" type="year"-->
          <!--                                placeholder="报告期"></el-date-picker>-->
          <!--                <div style="width: 7px;"></div>-->
          <!--                <el-button @click="getData">搜索</el-button>-->
        </div>
      </div>

      <div class="table-box">
        <div class="table-filter">
          标签：
          <template v-for="(item, index) in filterList">
            <div v-if="index == filterIndex" class="table-filter-item table-filter-item-selected"
              @click="changeFilter(index)">{{ item.name }}
            </div>
            <div v-else class="table-filter-item" @click="changeFilter(index)">{{ item.name }}</div>
          </template>
        </div>
        <table cellspacing="0">
          <thead>
            <tr>
              <th>排行</th>
              <th>股票代码</th>
              <th>公司简称</th>
              <!--                    <th>风险分数</th>-->
              <th>详情</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="tableData == null || tableData == undefined || tableData.length == 0">
              <tr>
                <td colspan="99">暂无数据</td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(item, index) in tableData" :key="index">
                <td>{{ serialNum(index) }}</td>
                <td style="color: #666666;">{{ item.stockCode }}</td>
                <td>{{ item.companyName }}</td>
                <!--                        <td>{{ item.riskScore }}</td>-->
                <td>
                  <div v-if="item.isAnalysis == 1" class="text-button-enable" @click="viewAnalysis(item)">查看
                  </div>
                  <div v-if="item.isAnalysis == 0" class="text-button-disable">查看</div>
                  <div class="text-button-enable" @click="viewCompany(item)">分析</div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div class="paging">
        <!-- <div class="pading-total"> -->
        <!-- 共&nbsp;{{ pages }}&nbsp;页&nbsp;&nbsp;&nbsp;&nbsp;当前&nbsp;{{ queryParam.pageNum }}&nbsp;页 -->
        <!-- 共&nbsp;{{ total }}&nbsp;条 -->
        <!-- </div> -->
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 15, 20, 30, 40, 50]"
          :current-page="queryParam.pageNum" :page-size="queryParam.pageSize" :total="total"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" class="paging-pages">
        </el-pagination>
      </div>

    </div>

    <div style="color:#9a9a9a; padding: 5px;margin-top: 30px;">
      免责声明：上述所有信息均基于市场公开数据，经数据自动处理技术和人工智能算法产生，碧湾将尽力但不能保证其绝对准确和可靠，且亦不会承担因任何不准确或遗漏而引起的任何损失或损害的责任。所有数据信息仅供参考，不构成任何投资建议，不代表碧湾观点，投资者据此操作，风险自担。
    </div>

  </div>
</template>
    
<script>
import { linkName, sendRequestIndustry } from '../../../../static/js/util';

export default {
  data() {
    return {
      searchText: '',
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        year: '2023',
        reportType: 2,
        firstType: 2,
        secondType: 1
      },
      filterList: [
        { name: '收入⬆利润⬇', value: 1 },
        { name: '收入⬇利润⬆', value: 2 },
        { name: '收入⬆利润⬆⬆', value: 3 },
        { name: '收入⬇利润⬇⬇', value: 4 },
        { name: '收入⬆⬆利润⬆', value: 5 },
        { name: '收入⬇⬇利润⬇', value: 6 },
      ],
      filterIndex: 0,
      total: 1,
      pages: 1,
      tableData: [],
      analysisVisible: false,
      analysisData: [],
      companyTemp: {}
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    back() {
      linkName(this, 'market');
    },
    //修改筛选
    changeFilter(num) {
      this.filterIndex = num;
      this.queryParam.secondType = this.filterList[num].value;
      this.queryParam.pageNum = 1;
      this.getData();
    },
    //排行序号
    serialNum(num) {
      return (this.queryParam.pageNum - 1) * this.queryParam.pageSize + num + 1;
    },
    //获取数据
    getData() {
      // const loading = this.$loading({
      //     target: $('.table-box')[0],
      //     lock: true,
      //     text: '加载中',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(255, 255, 255, 0.8)'
      // });
      sendRequestIndustry('/page/pageList' +
        '?pageNum=' + this.queryParam.pageNum +
        '&pageSize=' + this.queryParam.pageSize +
        '&year=' + this.queryParam.year +
        '&reportType=' + this.queryParam.reportType +
        '&firstType=' + this.queryParam.firstType +
        '&secondType=' + this.queryParam.secondType,
        'get',
        null,
        res => {
          // loading.close();
          // console.log(res)
          if (res.data.flag) {
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
            this.pages = res.data.data.pages;
          } else {
            this.tableData = [];
            this.total = 0;
            this.pages = 0;
          }
        }, err => {
          // loading.close();
          console.log(err);
        })
    },
    //每页多少条
    handleSizeChange(num) {
      this.queryParam.pageSize = num;
      this.getData();
    },
    //换页
    handleCurrentChange(index) {
      this.queryParam.pageNum = index;
      this.getData();
    },
    //查看分析结果
    viewAnalysis(row) {
      this.companyTemp = row;
      // this.$message('加载中');
      sendRequestIndustry('/page/rankAna' +
        '?stockCode=' + row.stockCode +
        '&year=' + row.year +
        '&reportType=' + row.reportType +
        '&firstType=' + row.firstType,
        'get',
        null,
        res => {
          // console.log(res)
          if (res.data.flag) {
            this.analysisData = res.data.data.infos;
            this.analysisVisible = true;
            try {
              linkName(this, 'analysis', {
                analysisData: this.analysisData,
                analysisCompany: this.companyTemp,
                analysisTitle: '收入/利润均衡 > ' + this.companyTemp.companyName
              });
            } catch (error) {
            }
          } else {
            // this.$message.error(res.data.msg);
            if (res.data.msg == '5002') {
              this.$alert('您的查看次数已用完，成为VIP即享碧湾所有分析数据', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  window.history.back();
                }
              });
            } else {
              console.log(res.data);
              this.$message.error(res.data.msg);
            }
          }
        }, err => {
          console.log(err)
          this.$message.error('请求出错');
        })
    },
    viewCompany(row) {
      linkName(this, 'business', {comCode: row.stockCode, comName: row.companyName});
    },
  }
};
</script>
    
<style scoped>
@import "../../../../static/css/marketItemView.css";
</style>